import React from 'react'
import Logo from '../Elem5-Logo/Elem5Logo.jsx';
import Elem2ReadReport from '../Elem2-ReadReport/Elem2ReadReport.jsx';
import Sec2TakeSurvey from '../Sec2-TakeSurvey/Sec2TakeSurvey.jsx';
import './Sec1Home.css';

function Sec1Home() {
  return (
    <div className='Sec1Home'>
      <div className='Container Sec1Home-Container'>
        <div className='Sec1Home-Left text'>
          <Logo/>
          <h1 className='text'>Maturity Index</h1>
          <h2 className='text'>Online Survey</h2>
            <p>
            The Maturity Assessment Portal (MAP) is an online tool that enables leaders to swiftly assess their company’s maturity across site strategy, operational efficiency, engineering, talent, and innovation.<br/><br/>With the MAP, leaders can effortlessly navigate a comprehensive survey designed to assess maturity levels across critical business areas. Upon completion, the tool benchmarks the company's results against a vast database of leading GCCs, offering a clear perspective on their position in the competitive landscape. It’s an essential tool for those aiming to drive growth, innovation, and leadership in their industries. Discover your company’s potential and chart a course for strategic excellence with MAP.
            </p>
        </div>
        <div className='Sec1Home-Right text'>
          <Sec2TakeSurvey/>
        </div>
      </div>
    </div>
  )
}

export default Sec1Home;
